import React from 'react';

const MyAgedCareOfficialLogo = () => (
    <div className="flex items-center gap-3">
        <div className="w-12 h-12 flex-shrink-0">
            <svg viewBox="0 0 100 60" xmlns="http://www.w3.org/2000/svg">
                <defs>
                    <linearGradient id="logoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#63b3ed" />
                        <stop offset="100%" stopColor="#4fd1c5" />
                    </linearGradient>
                </defs>
                <path fill="url(#logoGrad)" d="M36.8,35.4c-6.8,0-12.3-5.5-12.3-12.3S30,10.8,36.8,10.8s12.3,5.5,12.3,12.3C49.1,29.3,44.3,35.4,36.8,35.4z M63.2,49.2c-6.8,0-12.3-5.5-12.3-12.3c0-6.8,5.5-12.3,12.3-12.3s12.3,5.5,12.3,12.3C75.5,43.7,70,49.2,63.2,49.2z M49.4,42.4c-2.9,2.9-6.8,4.5-10.9,4.5c-4.1,0-8-1.6-10.9-4.5c-2.9-2.9-4.5-6.8-4.5-10.9c0-2.9,0.8-5.6,2.2-8H25c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7h2.5c1.8,4.4,5.7,7.6,10.4,8.5c-0.2,0.5-0.3,1-0.3,1.5c0,2.4,1.9,4.3,4.3,4.3s4.3-1.9,4.3-4.3c0-0.5-0.1-1-0.3-1.5c4.7-0.9,8.6-4.1,10.4-8.5h2.5c4.8,0,8.7,3.9,8.7,8.7c0-4.8-3.9-8.7-8.7-8.7h-1.1c1.4,2.4,2.2,5.1,2.2,8C60.3,35.6,55.9,40.1,49.4,42.4z"/>
            </svg>
        </div>
        <span className="font-bold text-xl text-[#5A2A82]">myagedcare</span>
    </div>
);

export default MyAgedCareOfficialLogo;
